// extracted by mini-css-extract-plugin
export default {"btnsLessonsContainer":"BtnsLessons_btnsLessonsContainer__JOncy","button":"BtnsLessons_button__UG+a6"};